import { render, staticRenderFns } from "./AccountPopover.vue?vue&type=template&id=5fc405a0&scoped=true&"
import script from "./AccountPopover.vue?vue&type=script&lang=js&"
export * from "./AccountPopover.vue?vue&type=script&lang=js&"
import style0 from "./AccountPopover.vue?vue&type=style&index=0&id=5fc405a0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc405a0",
  null
  
)

export default component.exports